import { render } from "./AttachFileUploadEditModal.vue?vue&type=template&id=648d748a"
import script from "./AttachFileUploadEditModal.vue?vue&type=script&lang=js"
export * from "./AttachFileUploadEditModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__